// Teller Online Library Files
import { HelpArticle } from 'teller-online-libraries/help';

// Article Files
import { CART_HELP_ARTICLES } from 'apps/public-portal/src/app/shared/help/articles/cart';
import { SEARCH_HELP_ARTICLES } from 'apps/public-portal/src/app/shared/help/articles/search';
import { CHECKOUT_HELP_ARTICLES } from 'apps/public-portal/src/app/shared/help/articles/checkout';
import {
    AUTHENTICATION_HELP_ARTICLES
} from 'apps/public-portal/src/app/shared/help/articles/authentication';
import {
    MANAGE_PROFILE_HELP_ARTICLES
} from 'apps/public-portal/src/app/shared/help/articles/manage-profile';
import {
    PAYMENT_METHODS_HELP_ARTICLES
} from 'apps/public-portal/src/app/shared/help/articles/payment-methods';
import {
    PAYMENT_HISTORY_HELP_ARTICLES
} from 'apps/public-portal/src/app/shared/help/articles/payment-history';
import {
    LINKED_ACCOUNTS_HELP_ARTICLES
} from 'apps/public-portal/src/app/shared/help/articles/linked-accounts';

/** Every public help article. Each tag's articles live in their own file. */
// Sorted by `order` (stable) so the combined list keeps its original sequence.
export const HELP_ARTICLES: HelpArticle[] = [
    ...CART_HELP_ARTICLES,
    ...SEARCH_HELP_ARTICLES,
    ...CHECKOUT_HELP_ARTICLES,
    ...AUTHENTICATION_HELP_ARTICLES,
    ...MANAGE_PROFILE_HELP_ARTICLES,
    ...PAYMENT_METHODS_HELP_ARTICLES,
    ...PAYMENT_HISTORY_HELP_ARTICLES,
    ...LINKED_ACCOUNTS_HELP_ARTICLES,
].sort((a, b) => a.order - b.order);
